"use strict";

// ============================================================
// RUTAS
// ============================================================

const RUTA_HRSEXTRA =
    "/hrsextra";

const RUTA_LISTAR =
    RUTA_HRSEXTRA + "/listar";

const RUTA_GUARDAR =
    RUTA_HRSEXTRA + "/guardar";

const RUTA_ACTUALIZAR =
    RUTA_HRSEXTRA + "/actualizar";

const RUTA_ELIMINAR =
    RUTA_HRSEXTRA + "/eliminar";


// ============================================================
// CONFIGURACIÓN
// ============================================================

// NO EXISTE VALOR POR DEFECTO DE DÍAS.
//
// EL USUARIO DEBE INGRESAR LOS DÍAS LABORALES.

const HORAS_POR_DIA = 8;


// ============================================================
// VARIABLES GLOBALES
// ============================================================

let empleados = [];

let horasExtras = [];

let guardandoHorasExtra = false;

let actualizandoHorasExtra = false;

let eliminandoHorasExtra = false;


// ============================================================
// INICIALIZAR
// ============================================================

document.addEventListener(
    "DOMContentLoaded",
    async function () {

        console.log("");

        console.log(
            "=========================================="
        );

        console.log(
            "INICIANDO HORAS EXTRAS"
        );

        console.log(
            "=========================================="
        );

        establecerFechaActual();

        configurarEventos();

        await cargarEmpleados();

        await cargarHorasExtras();

        requestAnimationFrame(
            function () {

                ajustarTablaHorasExtras();

            }
        );

        setTimeout(
            function () {

                ajustarTablaHorasExtras();

            },
            300
        );

        setTimeout(
            function () {

                ajustarTablaHorasExtras();

            },
            800
        );

    }
);


// ============================================================
// CONFIGURAR EVENTOS
// ============================================================

function configurarEventos() {

    // ========================================================
    // NUEVO
    // ========================================================

    const btnNuevaHoraExtra =
        document.getElementById(
            "btnNuevaHoraExtra"
        );

    if (btnNuevaHoraExtra) {

        btnNuevaHoraExtra.addEventListener(
            "click",
            abrirNuevaHoraExtra
        );

    }


    // ========================================================
    // GUARDAR
    // ========================================================

    const btnGuardarHoraExtra =
        document.getElementById(
            "btnGuardarHoraExtra"
        );

    if (btnGuardarHoraExtra) {

        btnGuardarHoraExtra.addEventListener(
            "click",
            guardarHoraExtra
        );

    }


    // ========================================================
    // ACTUALIZAR
    // ========================================================

    const btnActualizarHoraExtra =
        document.getElementById(
            "btnActualizarHoraExtra"
        );

    if (btnActualizarHoraExtra) {

        btnActualizarHoraExtra.addEventListener(
            "click",
            actualizarHoraExtra
        );

    }


    // ========================================================
    // EMPLEADO
    // ========================================================

    const idEmpleado =
        document.getElementById(
            "idEmpleado"
        );

    if (idEmpleado) {

        idEmpleado.addEventListener(
            "change",
            seleccionarEmpleado
        );

    }


    // ========================================================
    // SALARIO BASE
    //
    // Si el salario cambia manualmente o es actualizado
    // desde otro proceso, recalcula automáticamente.
    // ========================================================

    const salarioBase =
        document.getElementById(
            "salarioBase"
        );

    if (salarioBase) {

        salarioBase.addEventListener(
            "input",
            calcularNuevaHora
        );

        salarioBase.addEventListener(
            "change",
            calcularNuevaHora
        );

    }


    // ========================================================
    // DÍAS LABORALES
    // ========================================================

    const diasLaborales =
        document.getElementById(
            "diasLaborales"
        );

    if (diasLaborales) {

        diasLaborales.addEventListener(
            "input",
            calcularNuevaHora
        );

        diasLaborales.addEventListener(
            "change",
            calcularNuevaHora
        );

        diasLaborales.addEventListener(
            "keyup",
            calcularNuevaHora
        );

    }


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    const horasExtrasInput =
        document.getElementById(
            "horasExtras"
        );

    if (horasExtrasInput) {

        horasExtrasInput.addEventListener(
            "input",
            calcularNuevaHora
        );

        horasExtrasInput.addEventListener(
            "change",
            calcularNuevaHora
        );

        horasExtrasInput.addEventListener(
            "keyup",
            calcularNuevaHora
        );

    }


    // ========================================================
    // EDITAR SALARIO
    // ========================================================

    const editarSalarioBase =
        document.getElementById(
            "editarSalarioBase"
        );

    if (editarSalarioBase) {

        editarSalarioBase.addEventListener(
            "input",
            calcularEditarHora
        );

        editarSalarioBase.addEventListener(
            "change",
            calcularEditarHora
        );

    }


    // ========================================================
    // EDITAR DÍAS LABORALES
    // ========================================================

    const editarDiasLaborales =
        document.getElementById(
            "editarDiasLaborales"
        );

    if (editarDiasLaborales) {

        editarDiasLaborales.addEventListener(
            "input",
            calcularEditarHora
        );

        editarDiasLaborales.addEventListener(
            "change",
            calcularEditarHora
        );

        editarDiasLaborales.addEventListener(
            "keyup",
            calcularEditarHora
        );

    }


    // ========================================================
    // EDITAR HORAS EXTRAS
    // ========================================================

    const editarHorasExtras =
        document.getElementById(
            "editarHorasExtras"
        );

    if (editarHorasExtras) {

        editarHorasExtras.addEventListener(
            "input",
            calcularEditarHora
        );

        editarHorasExtras.addEventListener(
            "change",
            calcularEditarHora
        );

        editarHorasExtras.addEventListener(
            "keyup",
            calcularEditarHora
        );

    }


    // ========================================================
    // BUSCAR
    // ========================================================

    const buscarHoraExtra =
        document.getElementById(
            "buscarHoraExtra"
        );

    if (buscarHoraExtra) {

        buscarHoraExtra.addEventListener(
            "input",
            filtrarHorasExtras
        );

    }


    // ========================================================
    // LIMPIAR BÚSQUEDA
    // ========================================================

    const btnLimpiarBusqueda =
        document.getElementById(
            "btnLimpiarBusqueda"
        );

    if (btnLimpiarBusqueda) {

        btnLimpiarBusqueda.addEventListener(
            "click",
            function () {

                const buscar =
                    document.getElementById(
                        "buscarHoraExtra"
                    );

                if (buscar) {

                    buscar.value = "";

                }

                renderizarHorasExtras(
                    horasExtras
                );

                actualizarResumen();

                ajustarTablaHorasExtras();

            }
        );

    }

}


// ============================================================
// EVENTO DELEGADO
//
// Permite que el cálculo funcione aunque los inputs
// sean cargados posteriormente.
// ============================================================

document.addEventListener(
    "input",
    function (event) {

        if (!event.target) {

            return;

        }


        // ====================================================
        // NUEVO
        // ====================================================

        if (
            event.target.id ===
            "horasExtras"
        ) {

            calcularNuevaHora();

        }


        if (
            event.target.id ===
            "diasLaborales"
        ) {

            calcularNuevaHora();

        }


        if (
            event.target.id ===
            "salarioBase"
        ) {

            calcularNuevaHora();

        }


        // ====================================================
        // EDITAR
        // ====================================================

        if (
            event.target.id ===
            "editarHorasExtras"
        ) {

            calcularEditarHora();

        }


        if (
            event.target.id ===
            "editarDiasLaborales"
        ) {

            calcularEditarHora();

        }


        if (
            event.target.id ===
            "editarSalarioBase"
        ) {

            calcularEditarHora();

        }

    }
);


// ============================================================
// ESTABLECER FECHA ACTUAL
// ============================================================

function establecerFechaActual() {

    const fecha =
        document.getElementById(
            "fechaHoraExtra"
        );

    if (!fecha) {

        return;

    }


    const hoy =
        new Date();

    const anio =
        hoy.getFullYear();

    const mes =
        String(
            hoy.getMonth() + 1
        ).padStart(
            2,
            "0"
        );

    const dia =
        String(
            hoy.getDate()
        ).padStart(
            2,
            "0"
        );


    fecha.value =
        `${anio}-${mes}-${dia}`;

}


// ============================================================
// CARGAR EMPLEADOS
// ============================================================

async function cargarEmpleados() {

    try {

        console.log(
            "CARGANDO EMPLEADOS..."
        );


        const select =
            document.getElementById(
                "idEmpleado"
            );


        if (!select) {

            console.error(
                "No existe #idEmpleado"
            );

            return;

        }


        select.disabled = true;


        select.innerHTML = `
            <option value="">
                Cargando empleados...
            </option>
        `;


        const respuesta =
            await fetch(
                RUTA_HRSEXTRA,
                {
                    method: "GET",

                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                "Error HTTP " +
                respuesta.status
            );

        }


        const datos =
            await respuesta.json();


        console.log(
            "RESPUESTA EMPLEADOS:",
            datos
        );


        if (
            !datos ||
            datos.ok !== true
        ) {

            throw new Error(
                datos?.mensaje ||
                "El servidor no devolvió empleados."
            );

        }


        if (
            !Array.isArray(
                datos.data
            )
        ) {

            throw new Error(
                "La propiedad data no contiene un arreglo."
            );

        }


        const lista =
            datos.data;


        // ====================================================
        // ELIMINAR DUPLICADOS
        // ====================================================

        const mapaEmpleados =
            new Map();


        lista.forEach(
            function (empleado) {

                const id =
                    empleado.IDEMPLEADO;


                if (
                    id !== null &&
                    id !== undefined &&
                    String(id).trim() !== ""
                ) {

                    const clave =
                        String(id);


                    if (
                        !mapaEmpleados.has(
                            clave
                        )
                    ) {

                        mapaEmpleados.set(
                            clave,
                            empleado
                        );

                    }

                }

            }
        );


        empleados =
            Array.from(
                mapaEmpleados.values()
            );


        // ====================================================
        // ORDENAR POR NOMBRE
        // ====================================================

        empleados.sort(
            function (a, b) {

                const nombreA =
                    String(
                        a.NOMBREEMPLEADO || ""
                    ).toLowerCase();


                const nombreB =
                    String(
                        b.NOMBREEMPLEADO || ""
                    ).toLowerCase();


                return nombreA.localeCompare(
                    nombreB,
                    "es"
                );

            }
        );


        // ====================================================
        // LIMPIAR SELECT
        // ====================================================

        select.innerHTML = `
            <option value="">
                Seleccione un empleado
            </option>
        `;


        if (
            empleados.length === 0
        ) {

            select.innerHTML = `
                <option value="">
                    No hay empleados disponibles
                </option>
            `;

            select.disabled = true;

            return;

        }


        // ====================================================
        // LLENAR DROPDOWN
        // ====================================================

        empleados.forEach(
            function (empleado) {

                const id =
                    empleado.IDEMPLEADO ??
                    "";

                const nombre =
                    empleado.NOMBREEMPLEADO ??
                    "";

                const dpi =
                    empleado.DPI ??
                    "";

                const direccion =
                    empleado.DIRECCION ??
                    "";

                const puesto =
                    empleado.NOMBREPUESTO ??
                    "";

                const departamento =
                    empleado.NOMBRETECNOLOGICO ??
                    "";

                const salario =
                    empleado.SALARIOBASE ??
                    0;


                // =================================================
                // NO SE COLOCA 30 AUTOMÁTICAMENTE
                // =================================================

                const dias =
                    convertirNumero(
                        empleado.CANTIDADLABORALES
                    );


                const horasEstablecidas =
                    dias > 0
                        ? dias * HORAS_POR_DIA
                        : 0;


                const option =
                    document.createElement(
                        "option"
                    );


                option.value =
                    id;


                option.textContent =
                    `${id} - ${nombre}`;


                option.dataset.id =
                    id;


                option.dataset.nombre =
                    nombre;


                option.dataset.dpi =
                    dpi;


                option.dataset.direccion =
                    direccion;


                option.dataset.puesto =
                    puesto;


                option.dataset.departamento =
                    departamento;


                option.dataset.salario =
                    salario;


                option.dataset.dias =
                    dias;


                option.dataset.horasEstablecidas =
                    horasEstablecidas;


                select.appendChild(
                    option
                );

            }
        );


        select.disabled = false;


        console.log(
            "DROPDOWN CARGADO:",
            empleados
        );

    }
    catch (error) {

        console.error(
            "ERROR AL CARGAR EMPLEADOS:",
            error
        );


        const select =
            document.getElementById(
                "idEmpleado"
            );


        if (select) {

            select.innerHTML = `
                <option value="">
                    Error al cargar empleados
                </option>
            `;

            select.disabled = true;

        }

    }

}


// ============================================================
// OBTENER SALARIO BASE
// ============================================================

async function cargarSalarioBaseEmpleado(
    idEmpleado
) {

    try {

        const salarioInput =
            document.getElementById(
                "salarioBase"
            );


        if (salarioInput) {

            salarioInput.value =
                "Cargando...";

        }


        const respuesta =
            await fetch(
                `${RUTA_HRSEXTRA}/empleado/${encodeURIComponent(idEmpleado)}/salario`,
                {
                    method: "GET",

                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                "Error HTTP " +
                respuesta.status
            );

        }


        const resultado =
            await respuesta.json();


        if (
            !resultado ||
            resultado.ok !== true
        ) {

            throw new Error(
                resultado?.mensaje ||
                "No se pudo obtener el salario base."
            );

        }


        const salario =
            resultado.data?.SALARIOBASE ??
            resultado.data?.salarioBase ??
            0;


        establecerValor(
            "salarioBase",
            convertirNumero(
                salario
            ).toFixed(2)
        );


        // ====================================================
        // CALCULAR AUTOMÁTICAMENTE
        // ====================================================

        calcularNuevaHora();


        return salario;

    }
    catch (error) {

        console.warn(
            "NO SE PUDO CONSULTAR SALARIO:",
            error.message
        );


        const salarioActual =
            convertirNumero(
                obtenerValor(
                    "salarioBase"
                )
            );


        establecerValor(
            "salarioBase",
            salarioActual.toFixed(2)
        );


        calcularNuevaHora();


        return salarioActual;

    }

}


// ============================================================
// SELECCIONAR EMPLEADO
// ============================================================

async function seleccionarEmpleado() {

    const select =
        document.getElementById(
            "idEmpleado"
        );


    if (!select) {

        return;

    }


    const option =
        select.options[
            select.selectedIndex
        ];


    if (
        !option ||
        !option.value
    ) {

        limpiarDatosEmpleado();

        return;

    }


    const id =
        option.dataset.id ||
        "";


    const nombre =
        option.dataset.nombre ||
        "";


    const dpi =
        option.dataset.dpi ||
        "";


    const direccion =
        option.dataset.direccion ||
        "";


    const puesto =
        option.dataset.puesto ||
        "";


    const departamento =
        option.dataset.departamento ||
        "";


    const salario =
        option.dataset.salario ||
        0;


    // ========================================================
    // DÍAS LABORALES
    //
    // NO SE UTILIZA 30.
    //
    // SI EL EMPLEADO NO TIENE DÍAS GUARDADOS,
    // EL INPUT QUEDA VACÍO PARA QUE EL USUARIO LOS INGRESE.
    // ========================================================

    const dias =
        convertirNumero(
            option.dataset.dias
        );


    // ========================================================
    // ID
    // ========================================================

    establecerValor(
        "mostrarIdEmpleado",
        id
    );


    // ========================================================
    // NOMBRE
    // ========================================================

    establecerValor(
        "nombreEmpleado",
        nombre
    );


    // ========================================================
    // DPI
    // ========================================================

    establecerValor(
        "dpiEmpleado",
        dpi
    );


    // ========================================================
    // DIRECCIÓN
    // ========================================================

    establecerValor(
        "direccionEmpleado",
        direccion
    );


    // ========================================================
    // PUESTO
    // ========================================================

    establecerValor(
        "puestoEmpleado",
        puesto
    );


    // ========================================================
    // DEPARTAMENTO
    // ========================================================

    establecerValor(
        "departamentoTecnologico",
        departamento
    );


    // ========================================================
    // SALARIO
    // ========================================================

    establecerValor(
        "salarioBase",
        convertirNumero(
            salario
        ).toFixed(2)
    );


    // ========================================================
    // DÍAS LABORALES
    // ========================================================

    establecerValor(
        "diasLaborales",
        dias > 0
            ? dias
            : ""
    );


    // ========================================================
    // HORAS ESTABLECIDAS
    // ========================================================

    establecerValor(
        "hrsEstablecidas",
        dias > 0
            ? dias * HORAS_POR_DIA
            : ""
    );


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    establecerValor(
        "horasExtras",
        "0"
    );


    // ========================================================
    // ESTADO
    // ========================================================

    establecerValor(
        "estadoHoraExtra",
        "A"
    );


    // ========================================================
    // FECHA
    // ========================================================

    establecerFechaActual();


    // ========================================================
    // CALCULAR INMEDIATAMENTE
    // ========================================================

    calcularNuevaHora();


    // ========================================================
    // CONSULTAR SALARIO ACTUAL
    // ========================================================

    await cargarSalarioBaseEmpleado(
        id
    );


    // ========================================================
    // VOLVER A CALCULAR DESPUÉS DE OBTENER SALARIO
    // ========================================================

    calcularNuevaHora();

}


// ============================================================
// LIMPIAR DATOS EMPLEADO
// ============================================================

function limpiarDatosEmpleado() {

    const campos = [

        "mostrarIdEmpleado",

        "nombreEmpleado",

        "dpiEmpleado",

        "direccionEmpleado",

        "puestoEmpleado",

        "departamentoTecnologico",

        "salarioBase",

        "diasLaborales",

        "hrsEstablecidas",

        "horasExtras",

        "horaOrdinaria",

        "pagoHoraExtra",

        "montoHorasExtras"

    ];


    campos.forEach(
        function (id) {

            establecerValor(
                id,
                ""
            );

        }
    );

}


// ============================================================
// ABRIR NUEVO
// ============================================================

function abrirNuevaHoraExtra() {

    const formulario =
        document.getElementById(
            "formHoraExtra"
        );


    if (formulario) {

        formulario.reset();

    }


    establecerFechaActual();


    const select =
        document.getElementById(
            "idEmpleado"
        );


    if (select) {

        select.disabled = false;

        select.value = "";

    }


    limpiarDatosEmpleado();


    // ========================================================
    // DÍAS LABORALES
    //
    // VACÍO.
    // EL USUARIO DEBE INGRESAR EL VALOR.
    // ========================================================

    establecerValor(
        "diasLaborales",
        ""
    );


    // ========================================================
    // HORAS ESTABLECIDAS
    // ========================================================

    establecerValor(
        "hrsEstablecidas",
        ""
    );


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    establecerValor(
        "horasExtras",
        "0"
    );


    // ========================================================
    // SALARIO
    // ========================================================

    establecerValor(
        "salarioBase",
        "0.00"
    );


    // ========================================================
    // RESULTADOS
    // ========================================================

    establecerValor(
        "horaOrdinaria",
        "0.00"
    );


    establecerValor(
        "pagoHoraExtra",
        "0.00"
    );


    establecerValor(
        "montoHorasExtras",
        "0.00"
    );


    // ========================================================
    // ESTADO
    // ========================================================

    establecerValor(
        "estadoHoraExtra",
        "A"
    );


    // ========================================================
    // CALCULAR
    // ========================================================

    calcularNuevaHora();


    // ========================================================
    // MOSTRAR MODAL
    // ========================================================

    const modalElemento =
        document.getElementById(
            "modalHoraExtra"
        );


    if (modalElemento) {

        const modal =
            bootstrap.Modal.getOrCreateInstance(
                modalElemento
            );


        modal.show();

    }

}


// ============================================================
// CALCULAR NUEVA HORA EXTRA
//
// DÍAS LABORALES
//        ↓
// DÍAS × 8
//        ↓
// HORAS ESTABLECIDAS
//        ↓
// SALARIO ÷ HORAS ESTABLECIDAS
//        ↓
// PAGO HORA ORDINARIA
//        ↓
// PAGO HORA EXTRA
//        ↓
// HORAS EXTRAS × PAGO HORA EXTRA
//        ↓
// TOTAL
// ============================================================

function calcularNuevaHora() {

    console.log(
        "=========================================="
    );

    console.log(
        "CALCULANDO HORAS EXTRAS"
    );

    console.log(
        "=========================================="
    );


    // ========================================================
    // SALARIO
    // ========================================================

    const salario =
        convertirNumero(
            obtenerValor(
                "salarioBase"
            )
        );


    // ========================================================
    // DÍAS
    // ========================================================

    const dias =
        convertirNumero(
            obtenerValor(
                "diasLaborales"
            )
        );


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    const horasExtras =
        convertirNumero(
            obtenerValor(
                "horasExtras"
            )
        );


    console.log(
        "SALARIO BASE:",
        salario
    );

    console.log(
        "DÍAS LABORALES:",
        dias
    );

    console.log(
        "HORAS EXTRAS:",
        horasExtras
    );


    // ========================================================
    // VALIDAR DÍAS
    // ========================================================

    if (
        dias <= 0
    ) {

        establecerValor(
            "hrsEstablecidas",
            ""
        );

        establecerValor(
            "horaOrdinaria",
            "0.00"
        );

        establecerValor(
            "pagoHoraExtra",
            "0.00"
        );

        establecerValor(
            "montoHorasExtras",
            "0.00"
        );


        console.log(
            "DÍAS LABORALES NO INGRESADOS."
        );


        return;

    }


    // ========================================================
    // HORAS ESTABLECIDAS
    // ========================================================
    //
    // DÍAS × 8
    // ========================================================

    const horasEstablecidas =
        dias *
        HORAS_POR_DIA;


    establecerValor(
        "hrsEstablecidas",
        horasEstablecidas
    );


    console.log(
        "HORAS ESTABLECIDAS:",
        horasEstablecidas
    );


    // ========================================================
    // PAGO HORA ORDINARIA
    // ========================================================
    //
    // SALARIO ÷ HORAS ESTABLECIDAS
    // ========================================================

    let pagoHoraOrdinaria = 0;


    if (
        salario > 0 &&
        horasEstablecidas > 0
    ) {

        pagoHoraOrdinaria =
            salario /
            horasEstablecidas;

    }


    establecerValor(
        "horaOrdinaria",
        pagoHoraOrdinaria.toFixed(2)
    );


    console.log(
        "PAGO HORA ORDINARIA:",
        pagoHoraOrdinaria
    );


    // ========================================================
    // PAGO HORA EXTRA
    // ========================================================
    //
    // SE MANTIENE LA OPERACIÓN ORIGINAL.
    // ========================================================

    const pagoHoraExtra =
        pagoHoraOrdinaria;


    establecerValor(
        "pagoHoraExtra",
        pagoHoraExtra.toFixed(2)
    );


    console.log(
        "PAGO HORA EXTRA:",
        pagoHoraExtra
    );


    // ========================================================
    // TOTAL HORAS EXTRAS
    // ========================================================
    //
    // HORAS EXTRAS × PAGO HORA EXTRA
    // ========================================================

    const totalHorasExtras =
        horasExtras *
        pagoHoraExtra;


    establecerValor(
        "montoHorasExtras",
        totalHorasExtras.toFixed(2)
    );


    console.log(
        "TOTAL HORAS EXTRAS:",
        totalHorasExtras
    );


    console.log(
        "=========================================="
    );

}


// ============================================================
// CARGAR LISTADO
// ============================================================

async function cargarHorasExtras() {

    try {

        console.log(
            "=========================================="
        );

        console.log(
            "CARGANDO LISTADO DE HORAS EXTRAS"
        );

        console.log(
            "RUTA:",
            RUTA_LISTAR
        );

        console.log(
            "=========================================="
        );


        const respuesta =
            await fetch(
                RUTA_LISTAR,
                {
                    method: "GET",

                    headers: {
                        "Accept":
                            "application/json"
                    }
                }
            );


        if (!respuesta.ok) {

            throw new Error(
                "Error HTTP " +
                respuesta.status
            );

        }


        const datos =
            await respuesta.json();


        console.log(
            "RESPUESTA LISTAR:",
            datos
        );


        if (
            datos &&
            datos.ok === true &&
            Array.isArray(
                datos.data
            )
        ) {

            horasExtras =
                datos.data;

        }
        else if (
            Array.isArray(datos)
        ) {

            horasExtras =
                datos;

        }
        else {

            horasExtras = [];

        }


        renderizarHorasExtras(
            horasExtras
        );


        actualizarResumen();


        requestAnimationFrame(
            function () {

                ajustarTablaHorasExtras();

            }
        );

    }
    catch (error) {

        console.error(
            "ERROR AL CARGAR LISTADO:",
            error
        );


        horasExtras = [];


        renderizarHorasExtras(
            []
        );


        actualizarResumen();


        requestAnimationFrame(
            function () {

                ajustarTablaHorasExtras();

            }
        );

    }

}


// ============================================================
// AJUSTAR TABLA
// ============================================================

function ajustarTablaHorasExtras() {

    const tabla =
        document.getElementById(
            "tablaHorasExtra"
        );


    const tbody =
        document.getElementById(
            "tbodyHorasExtra"
        );


    if (
        !tabla ||
        !tbody
    ) {

        return;

    }


    tabla.style.display = "none";


    void tabla.offsetHeight;


    tabla.style.display = "";


    tabla.style.minWidth =
        "1900px";


    tabla.style.width =
        "max-content";


    tabla.style.tableLayout =
        "auto";


    requestAnimationFrame(
        function () {

            void tabla.offsetWidth;


            tabla.style.tableLayout =
                "fixed";


            requestAnimationFrame(
                function () {

                    void tabla.offsetWidth;

                }
            );

        }
    );

}


// ============================================================
// RENDERIZAR TABLA
// ============================================================

function renderizarHorasExtras(
    lista
) {

    const tbody =
        document.getElementById(
            "tbodyHorasExtra"
        );


    if (!tbody) {

        return;

    }


    tbody.innerHTML = "";


    if (
        !Array.isArray(lista) ||
        lista.length === 0
    ) {

        tbody.innerHTML = `
            <tr>
                <td
                    colspan="15"
                    class="text-center py-4"
                >
                    No hay registros de horas extras.
                </td>
            </tr>
        `;


        ajustarTablaHorasExtras();


        return;

    }


    lista.forEach(
        function (item) {

            const idEmpleado =
                item.IDEMPLEADO ??
                "";


            const nombre =
                item.NOMBREEMPLEADO ??
                "";


            const dpi =
                item.DPI ??
                "";


            const direccion =
                item.DIRECCION ??
                "";


            const puesto =
                item.NOMBREPUESTO ??
                "";


            const salario =
                item.SALARIOBASE ??
                0;


            // =================================================
            // DÍAS
            // =================================================

            const dias =
                convertirNumero(
                    item.CANTIDADLABORALES
                );


            // =================================================
            // HORAS ESTABLECIDAS
            // =================================================

            const horasEstablecidas =
                dias > 0
                    ? dias * HORAS_POR_DIA
                    : 0;


            // =================================================
            // HORAS EXTRAS
            // =================================================

            const horasExtra =
                item.HORASEXTRAS ??
                0;


            // =================================================
            // PAGO HORA ORDINARIA
            //
            // PRIMERO INTENTA USAR EL VALOR DEL SQL.
            // SI NO VIENE, CALCULA:
            //
            // SALARIO / HORAS ESTABLECIDAS
            // =================================================

            let pagoOrdinaria =
                convertirNumero(
                    item.PAGOORDINARIAHREXTRA
                );


            if (
                pagoOrdinaria <= 0 &&
                salario > 0 &&
                horasEstablecidas > 0
            ) {

                pagoOrdinaria =
                    convertirNumero(
                        salario
                    ) /
                    horasEstablecidas;

            }


            // =================================================
            // PAGO HORA EXTRA
            // =================================================

            let pagoExtra =
                convertirNumero(
                    item.PAGOEXTRA
                );


            if (
                pagoExtra <= 0 &&
                pagoOrdinaria > 0
            ) {

                pagoExtra =
                    pagoOrdinaria;

            }


            // =================================================
            // TOTAL
            // =================================================

            let totalExtra =
                convertirNumero(
                    item.TOTALEXTRAPAGADO
                );


            if (
                totalExtra <= 0 &&
                horasExtra > 0 &&
                pagoExtra > 0
            ) {

                totalExtra =
                    convertirNumero(
                        horasExtra
                    ) *
                    pagoExtra;

            }


            const fecha =
                item.FECHAINGRESO ??
                "";


            const estado =
                item.ESTADO ??
                "A";


            // =================================================
            // CREAR FILA
            // =================================================

            const tr =
                document.createElement(
                    "tr"
                );


            tr.innerHTML = `
                <td>
                    ${escaparHTML(
                        idEmpleado
                    )}
                </td>

                <td>
                    ${escaparHTML(
                        nombre
                    )}
                </td>

                <td>
                    ${escaparHTML(
                        dpi
                    )}
                </td>

                <td>
                    ${escaparHTML(
                        direccion
                    )}
                </td>

                <td>
                    ${escaparHTML(
                        puesto
                    )}
                </td>

                <td class="text-end">
                    Q ${formatearNumero(
                        salario
                    )}
                </td>

                <td class="text-center">
                    ${
                        dias > 0
                            ? escaparHTML(
                                dias
                            )
                            : ""
                    }
                </td>

                <td class="text-center">
                    ${
                        horasEstablecidas > 0
                            ? escaparHTML(
                                horasEstablecidas
                            )
                            : ""
                    }
                </td>

                <td class="text-center">
                    ${escaparHTML(
                        horasExtra
                    )}
                </td>

                <td class="text-end">
                    Q ${formatearNumero(
                        pagoOrdinaria
                    )}
                </td>

                <td class="text-end">
                    Q ${formatearNumero(
                        pagoExtra
                    )}
                </td>

                <td class="text-end">
                    Q ${formatearNumero(
                        totalExtra
                    )}
                </td>

                <td class="text-center">
                    ${escaparHTML(
                        convertirFechaMostrar(
                            fecha
                        )
                    )}
                </td>

                <td class="text-center">
                    ${crearBadgeEstado(
                        estado
                    )}
                </td>

                <td class="text-center">

                    <button
                        type="button"
                        class="btn btn-sm btn-warning"
                        onclick="abrirEditarHoraExtra(${escaparAtributo(idEmpleado)})"
                        title="Editar"
                    >
                        <i class="bi bi-pencil-square"></i>
                    </button>

                    <button
                        type="button"
                        class="btn btn-sm btn-danger"
                        onclick="eliminarHoraExtra(${escaparAtributo(idEmpleado)})"
                        title="Eliminar"
                    >
                        <i class="bi bi-trash"></i>
                    </button>

                </td>
            `;


            tbody.appendChild(
                tr
            );

        }
    );


    requestAnimationFrame(
        function () {

            ajustarTablaHorasExtras();

        }
    );

}


// ============================================================
// BADGE ESTADO
// ============================================================

function crearBadgeEstado(
    estado
) {

    const valor =
        String(
            estado || "A"
        ).toUpperCase();


    if (
        valor === "A"
    ) {

        return `
            <span class="badge bg-success">
                ACTIVO
            </span>
        `;

    }


    if (
        valor === "I"
    ) {

        return `
            <span class="badge bg-secondary">
                INACTIVO
            </span>
        `;

    }


    if (
        valor === "P"
    ) {

        return `
            <span class="badge bg-warning text-dark">
                PENDIENTE
            </span>
        `;

    }


    if (
        valor === "D"
    ) {

        return `
            <span class="badge bg-danger">
                ELIMINADO
            </span>
        `;

    }


    return `
        <span class="badge bg-dark">
            ${escaparHTML(valor)}
        </span>
    `;

}


// ============================================================
// GUARDAR
// ============================================================

async function guardarHoraExtra() {

    if (
        guardandoHorasExtra
    ) {

        return;

    }


    try {

        guardandoHorasExtra = true;


        const idEmpleado =
            obtenerValor(
                "mostrarIdEmpleado"
            );


        const dpi =
            obtenerValor(
                "dpiEmpleado"
            );


        const dias =
            convertirNumero(
                obtenerValor(
                    "diasLaborales"
                )
            );


        const horas =
            convertirNumero(
                obtenerValor(
                    "horasExtras"
                )
            );


        const fecha =
            obtenerValor(
                "fechaHoraExtra"
            );


        const estado =
            obtenerValor(
                "estadoHoraExtra"
            ) || "A";


        // ====================================================
        // VALIDAR DÍAS
        // ====================================================

        if (
            dias <= 0
        ) {

            alert(
                "Ingrese la cantidad de días laborales."
            );

            return;

        }


        // ====================================================
        // VALIDAR EMPLEADO
        // ====================================================

        if (!idEmpleado) {

            alert(
                "Seleccione un empleado."
            );

            return;

        }


        // ====================================================
        // VALIDAR DPI
        // ====================================================

        if (!dpi) {

            alert(
                "El empleado seleccionado no tiene DPI."
            );

            return;

        }


        // ====================================================
        // VALIDAR HORAS
        // ====================================================

        if (
            horas < 0
        ) {

            alert(
                "Las horas extras no pueden ser negativas."
            );

            return;

        }


        // ====================================================
        // VALIDAR FECHA
        // ====================================================

        if (!fecha) {

            alert(
                "Seleccione una fecha."
            );

            return;

        }


        // ====================================================
        // DATOS
        // ====================================================

        const datos = {

            IDEMPLEADO:
                Number(
                    idEmpleado
                ),

            DPI:
                dpi,

            CANTIDADLABORALES:
                Number.parseInt(
                    dias,
                    10
                ),

            DIASLABORALES:
                Number.parseInt(
                    dias,
                    10
                ),

            HORASEXTRAS:
                Number.parseInt(
                    horas,
                    10
                ),

            FECHAINGRESO:
                fecha,

            ESTADO:
                estado

        };


        console.log(
            "DATOS GUARDAR:",
            datos
        );


        const respuesta =
            await fetch(
                RUTA_GUARDAR,
                {
                    method: "POST",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                "No se pudo guardar."
            );

        }


        alert(
            resultado.mensaje ||
            "Hora extra guardada correctamente."
        );


        // ====================================================
        // CERRAR MODAL
        // ====================================================

        const modalElemento =
            document.getElementById(
                "modalHoraExtra"
            );


        if (modalElemento) {

            const modal =
                bootstrap.Modal.getInstance(
                    modalElemento
                );


            if (modal) {

                modal.hide();

            }

        }


        // ====================================================
        // RECARGAR
        // ====================================================

        await cargarEmpleados();

        await cargarHorasExtras();

        ajustarTablaHorasExtras();

    }
    catch (error) {

        console.error(
            "ERROR AL GUARDAR:",
            error
        );


        alert(
            error.message ||
            "Error al guardar."
        );

    }
    finally {

        guardandoHorasExtra = false;

    }

}


// ============================================================
// ABRIR EDITAR
// ============================================================

function abrirEditarHoraExtra(
    idEmpleado
) {

    const registro =
        horasExtras.find(
            function (item) {

                return Number(
                    item.IDEMPLEADO
                ) ===
                Number(
                    idEmpleado
                );

            }
        );


    if (!registro) {

        alert(
            "No se encontró el registro."
        );

        return;

    }


    // ========================================================
    // ID
    // ========================================================

    establecerValor(
        "editarIdEmpleado",
        registro.IDEMPLEADO
    );


    establecerValor(
        "editarIdEmpleadoMostrar",
        registro.IDEMPLEADO
    );


    // ========================================================
    // NOMBRE
    // ========================================================

    establecerValor(
        "editarNombreEmpleado",
        registro.NOMBREEMPLEADO ||
        ""
    );


    // ========================================================
    // DPI
    // ========================================================

    establecerValor(
        "editarDpi",
        registro.DPI ||
        ""
    );


    // ========================================================
    // DIRECCIÓN
    // ========================================================

    establecerValor(
        "editarDireccion",
        registro.DIRECCION ||
        ""
    );


    // ========================================================
    // PUESTO
    // ========================================================

    establecerValor(
        "editarPuesto",
        registro.NOMBREPUESTO ||
        ""
    );


    // ========================================================
    // SALARIO
    // ========================================================

    establecerValor(
        "editarSalarioBase",
        convertirNumero(
            registro.SALARIOBASE
        ).toFixed(2)
    );


    // ========================================================
    // DÍAS LABORALES
    // ========================================================

    const dias =
        convertirNumero(
            registro.CANTIDADLABORALES
        );


    establecerValor(
        "editarDiasLaborales",
        dias > 0
            ? dias
            : ""
    );


    // ========================================================
    // HORAS ESTABLECIDAS
    // ========================================================

    establecerValor(
        "editarHrsEstablecidas",
        dias > 0
            ? dias * HORAS_POR_DIA
            : ""
    );


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    establecerValor(
        "editarHorasExtras",
        registro.HORASEXTRAS ?? 0
    );


    // ========================================================
    // ESTADO
    // ========================================================

    establecerValor(
        "editarEstado",
        registro.ESTADO ||
        "A"
    );


    // ========================================================
    // FECHA
    // ========================================================

    establecerValor(
        "editarFecha",
        convertirFechaInput(
            registro.FECHAINGRESO
        )
    );


    // ========================================================
    // CALCULAR AUTOMÁTICAMENTE
    // ========================================================

    calcularEditarHora();


    // ========================================================
    // MOSTRAR MODAL
    // ========================================================

    const modalElemento =
        document.getElementById(
            "modalEditarHoraExtra"
        );


    if (modalElemento) {

        const modal =
            bootstrap.Modal.getOrCreateInstance(
                modalElemento
            );


        modal.show();

    }

}


// ============================================================
// CALCULAR EDICIÓN
// ============================================================

function calcularEditarHora() {

    console.log(
        "=========================================="
    );

    console.log(
        "CALCULANDO EDICIÓN DE HORAS EXTRAS"
    );

    console.log(
        "=========================================="
    );


    // ========================================================
    // SALARIO
    // ========================================================

    const salario =
        convertirNumero(
            obtenerValor(
                "editarSalarioBase"
            )
        );


    // ========================================================
    // DÍAS
    // ========================================================

    const dias =
        convertirNumero(
            obtenerValor(
                "editarDiasLaborales"
            )
        );


    // ========================================================
    // HORAS EXTRAS
    // ========================================================

    const horasExtras =
        convertirNumero(
            obtenerValor(
                "editarHorasExtras"
            )
        );


    console.log(
        "SALARIO EDICIÓN:",
        salario
    );

    console.log(
        "DÍAS EDICIÓN:",
        dias
    );

    console.log(
        "HORAS EXTRAS EDICIÓN:",
        horasExtras
    );


    // ========================================================
    // VALIDAR DÍAS
    // ========================================================

    if (
        dias <= 0
    ) {

        establecerValor(
            "editarHrsEstablecidas",
            ""
        );

        establecerValor(
            "editarHoraOrdinaria",
            "0.00"
        );

        establecerValor(
            "editarPagoHoraExtra",
            "0.00"
        );

        establecerValor(
            "editarMontoHorasExtras",
            "0.00"
        );


        return;

    }


    // ========================================================
    // HORAS ESTABLECIDAS
    // ========================================================

    const horasEstablecidas =
        dias *
        HORAS_POR_DIA;


    establecerValor(
        "editarHrsEstablecidas",
        horasEstablecidas
    );


    // ========================================================
    // PAGO HORA ORDINARIA
    // ========================================================

    let pagoHoraOrdinaria = 0;


    if (
        salario > 0 &&
        horasEstablecidas > 0
    ) {

        pagoHoraOrdinaria =
            salario /
            horasEstablecidas;

    }


    establecerValor(
        "editarHoraOrdinaria",
        pagoHoraOrdinaria.toFixed(2)
    );


    // ========================================================
    // PAGO HORA EXTRA
    // ========================================================

    const pagoHoraExtra =
        pagoHoraOrdinaria;


    establecerValor(
        "editarPagoHoraExtra",
        pagoHoraExtra.toFixed(2)
    );


    // ========================================================
    // TOTAL
    // ========================================================

    const totalHorasExtras =
        horasExtras *
        pagoHoraExtra;


    establecerValor(
        "editarMontoHorasExtras",
        totalHorasExtras.toFixed(2)
    );


    console.log(
        "HORAS ESTABLECIDAS EDICIÓN:",
        horasEstablecidas
    );

    console.log(
        "PAGO HORA ORDINARIA EDICIÓN:",
        pagoHoraOrdinaria
    );

    console.log(
        "PAGO HORA EXTRA EDICIÓN:",
        pagoHoraExtra
    );

    console.log(
        "TOTAL EDICIÓN:",
        totalHorasExtras
    );

}


// ============================================================
// ACTUALIZAR
// ============================================================

async function actualizarHoraExtra() {

    if (
        actualizandoHorasExtra
    ) {

        return;

    }


    try {

        actualizandoHorasExtra = true;


        const idEmpleado =
            obtenerValor(
                "editarIdEmpleado"
            );


        const dias =
            convertirNumero(
                obtenerValor(
                    "editarDiasLaborales"
                )
            );


        const horas =
            convertirNumero(
                obtenerValor(
                    "editarHorasExtras"
                )
            );


        const estado =
            obtenerValor(
                "editarEstado"
            ) || "A";


        // ====================================================
        // VALIDAR ID
        // ====================================================

        if (!idEmpleado) {

            alert(
                "No se encontró el ID del empleado."
            );

            return;

        }


        // ====================================================
        // VALIDAR DÍAS
        // ====================================================

        if (
            dias <= 0
        ) {

            alert(
                "Ingrese la cantidad de días laborales."
            );

            return;

        }


        // ====================================================
        // VALIDAR HORAS
        // ====================================================

        if (
            horas < 0
        ) {

            alert(
                "Las horas extras no pueden ser negativas."
            );

            return;

        }


        // ====================================================
        // DATOS
        // ====================================================

        const datos = {

            IDEMPLEADO:
                Number(
                    idEmpleado
                ),

            CANTIDADLABORALES:
                Number.parseInt(
                    dias,
                    10
                ),

            DIASLABORALES:
                Number.parseInt(
                    dias,
                    10
                ),

            HORASEXTRAS:
                Number.parseInt(
                    horas,
                    10
                ),

            ESTADO:
                estado

        };


        console.log(
            "DATOS ACTUALIZAR:",
            datos
        );


        const respuesta =
            await fetch(
                RUTA_ACTUALIZAR,
                {
                    method: "PUT",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                "No se pudo actualizar."
            );

        }


        alert(
            resultado.mensaje ||
            "Hora extra actualizada correctamente."
        );


        // ====================================================
        // CERRAR MODAL
        // ====================================================

        const modalElemento =
            document.getElementById(
                "modalEditarHoraExtra"
            );


        if (modalElemento) {

            const modal =
                bootstrap.Modal.getInstance(
                    modalElemento
                );


            if (modal) {

                modal.hide();

            }

        }


        // ====================================================
        // RECARGAR
        // ====================================================

        await cargarEmpleados();

        await cargarHorasExtras();

        ajustarTablaHorasExtras();

    }
    catch (error) {

        console.error(
            "ERROR AL ACTUALIZAR:",
            error
        );


        alert(
            error.message ||
            "Error al actualizar."
        );

    }
    finally {

        actualizandoHorasExtra = false;

    }

}


// ============================================================
// ELIMINAR
// ============================================================

async function eliminarHoraExtra(
    idEmpleado
) {

    if (
        eliminandoHorasExtra
    ) {

        return;

    }


    const confirmar =
        confirm(
            "¿Está seguro de eliminar las horas extras de este empleado?"
        );


    if (!confirmar) {

        return;

    }


    try {

        eliminandoHorasExtra = true;


        const datos = {

            IDEMPLEADO:
                Number(
                    idEmpleado
                )

        };


        console.log(
            "DATOS ELIMINAR:",
            datos
        );


        const respuesta =
            await fetch(
                RUTA_ELIMINAR,
                {
                    method: "PUT",

                    headers: {

                        "Content-Type":
                            "application/json",

                        "Accept":
                            "application/json"

                    },

                    body:
                        JSON.stringify(
                            datos
                        )

                }
            );


        const resultado =
            await respuesta.json();


        if (!respuesta.ok) {

            throw new Error(
                resultado.mensaje ||
                resultado.message ||
                "No se pudo eliminar."
            );

        }


        alert(
            resultado.mensaje ||
            "Registro eliminado correctamente."
        );


        await cargarEmpleados();

        await cargarHorasExtras();

        ajustarTablaHorasExtras();

    }
    catch (error) {

        console.error(
            "ERROR AL ELIMINAR:",
            error
        );


        alert(
            error.message ||
            "Error al eliminar."
        );

    }
    finally {

        eliminandoHorasExtra = false;

    }

}


// ============================================================
// FILTRAR
// ============================================================

function filtrarHorasExtras() {

    const input =
        document.getElementById(
            "buscarHoraExtra"
        );


    if (!input) {

        return;

    }


    const texto =
        input.value
            .toLowerCase()
            .trim();


    if (!texto) {

        renderizarHorasExtras(
            horasExtras
        );

        actualizarResumen();

        ajustarTablaHorasExtras();

        return;

    }


    const filtrados =
        horasExtras.filter(
            function (item) {

                const id =
                    String(
                        item.IDEMPLEADO ??
                        ""
                    ).toLowerCase();


                const nombre =
                    String(
                        item.NOMBREEMPLEADO ??
                        ""
                    ).toLowerCase();


                const dpi =
                    String(
                        item.DPI ??
                        ""
                    ).toLowerCase();


                const direccion =
                    String(
                        item.DIRECCION ??
                        ""
                    ).toLowerCase();


                const puesto =
                    String(
                        item.NOMBREPUESTO ??
                        ""
                    ).toLowerCase();


                const salario =
                    String(
                        item.SALARIOBASE ??
                        ""
                    ).toLowerCase();


                const horas =
                    String(
                        item.HORASEXTRAS ??
                        ""
                    ).toLowerCase();


                return (

                    id.includes(texto) ||

                    nombre.includes(texto) ||

                    dpi.includes(texto) ||

                    direccion.includes(texto) ||

                    puesto.includes(texto) ||

                    salario.includes(texto) ||

                    horas.includes(texto)

                );

            }
        );


    renderizarHorasExtras(
        filtrados
    );


    ajustarTablaHorasExtras();

}


// ============================================================
// ACTUALIZAR RESUMEN
// ============================================================

function actualizarResumen() {

    const totalEmpleados =
        document.getElementById(
            "totalEmpleados"
        );


    const totalHorasExtras =
        document.getElementById(
            "totalHorasExtras"
        );


    const totalPagoHoras =
        document.getElementById(
            "totalPagoHoras"
        );


    if (totalEmpleados) {

        totalEmpleados.textContent =
            horasExtras.length;

    }


    let sumaHorasExtras = 0;

    let sumaPago = 0;


    horasExtras.forEach(
        function (item) {

            sumaHorasExtras +=
                convertirNumero(
                    item.HORASEXTRAS
                );


            sumaPago +=
                convertirNumero(
                    item.TOTALEXTRAPAGADO
                );

        }
    );


    if (totalHorasExtras) {

        totalHorasExtras.textContent =
            formatearNumero(
                sumaHorasExtras
            );

    }


    if (totalPagoHoras) {

        totalPagoHoras.textContent =
            "Q " +
            formatearNumero(
                sumaPago
            );

    }

}


// ============================================================
// OBTENER VALOR
// ============================================================

function obtenerValor(
    id
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        return "";

    }


    return elemento.value;

}


// ============================================================
// ESTABLECER VALOR
// ============================================================

function establecerValor(
    id,
    valor
) {

    const elemento =
        document.getElementById(
            id
        );


    if (!elemento) {

        console.warn(
            "NO EXISTE EL ELEMENTO:",
            id
        );

        return;

    }


    elemento.value =
        valor ?? "";

}


// ============================================================
// CONVERTIR A NÚMERO
// ============================================================

function convertirNumero(
    valor
) {

    if (
        valor === null ||
        valor === undefined ||
        valor === ""
    ) {

        return 0;

    }


    if (
        typeof valor === "number"
    ) {

        return isNaN(valor)
            ? 0
            : valor;

    }


    let texto =
        String(valor)
            .trim()
            .replace(
                /Q/gi,
                ""
            )
            .replace(
                /\s/g,
                ""
            );


    if (
        texto.includes(",") &&
        texto.includes(".")
    ) {

        texto =
            texto.replace(
                /,/g,
                ""
            );

    }
    else if (
        texto.includes(",")
    ) {

        texto =
            texto.replace(
                ",",
                "."
            );

    }


    const numero =
        parseFloat(
            texto
        );


    return isNaN(numero)
        ? 0
        : numero;

}


// ============================================================
// FORMATEAR NÚMERO
// ============================================================

function formatearNumero(
    valor
) {

    const numero =
        convertirNumero(
            valor
        );


    return numero.toLocaleString(
        "es-GT",
        {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }
    );

}


// ============================================================
// CONVERTIR FECHA PARA INPUT
// ============================================================

function convertirFechaInput(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const texto =
        String(
            fecha
        ).trim();


    if (
        /^\d{4}-\d{2}-\d{2}$/.test(
            texto
        )
    ) {

        return texto;

    }


    if (
        texto.includes("T")
    ) {

        return texto.substring(
            0,
            10
        );

    }


    if (
        /^\d{2}\/\d{2}\/\d{4}$/.test(
            texto
        )
    ) {

        const partes =
            texto.split("/");


        return (
            partes[2] +
            "-" +
            partes[1] +
            "-" +
            partes[0]
        );

    }


    return "";

}


// ============================================================
// CONVERTIR FECHA PARA MOSTRAR
// ============================================================

function convertirFechaMostrar(
    fecha
) {

    if (!fecha) {

        return "";

    }


    const texto =
        String(
            fecha
        ).trim();


    if (
        texto.includes("T")
    ) {

        return texto.substring(
            0,
            10
        );

    }


    return texto;

}


// ============================================================
// ESCAPAR HTML
// ============================================================

function escaparHTML(
    valor
) {

    return String(
        valor ?? ""
    )

        .replace(
            /&/g,
            "&amp;"
        )

        .replace(
            /</g,
            "&lt;"
        )

        .replace(
            />/g,
            "&gt;"
        )

        .replace(
            /"/g,
            "&quot;"
        )

        .replace(
            /'/g,
            "&#039;"
        );

}


// ============================================================
// ESCAPAR ATRIBUTO
// ============================================================

function escaparAtributo(
    valor
) {

    const numero =
        convertirNumero(
            valor
        );


    return Number.isFinite(
        numero
    )
        ? numero
        : 0;

}


// ============================================================
// EXPONER FUNCIONES GLOBALMENTE
// ============================================================

window.abrirEditarHoraExtra =
    abrirEditarHoraExtra;

window.eliminarHoraExtra =
    eliminarHoraExtra;

window.abrirNuevaHoraExtra =
    abrirNuevaHoraExtra;

window.cargarHorasExtras =
    cargarHorasExtras;

window.cargarEmpleados =
    cargarEmpleados;

window.seleccionarEmpleado =
    seleccionarEmpleado;

window.guardarHoraExtra =
    guardarHoraExtra;

window.actualizarHoraExtra =
    actualizarHoraExtra;

window.cargarSalarioBaseEmpleado =
    cargarSalarioBaseEmpleado;

window.calcularNuevaHora =
    calcularNuevaHora;

window.calcularEditarHora =
    calcularEditarHora;

window.filtrarHorasExtras =
    filtrarHorasExtras;

window.ajustarTablaHorasExtras =
    ajustarTablaHorasExtras;